import { useTranslation } from 'react-i18next';

import { IProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/Index';

export const Inputs = (props: IProps) => {
	const { t } = useTranslation();

	return (
		<input
			type="text"
			className="form-control"
			error-key="Name"
			placeholder={t('standingData:NAME')}
			value={props.erpRecipe.name}
			onChange={(e) =>
				props.handlers.changeErpRecipeName({
					id: props.erpRecipe.id,
					name: e.target.value,
				})
			}
		/>
	);
};
